import style from "./style.module.css";
// import {FaRegCheckCircle} from "react-icons/fa";

function MessageBox({message, setMessage}) {
    var msg = message.message?message.message:message;
    var type = message.type?message.type:0;
    type = ((type==-1)?"btn-danger":((type==1)?"btn-success":"btn-secondary"));
    return (
        <div className={style.container}>
            <div className={style.box}>
                <div className={style.box_content}>
                    <div className={style.message}>
                        {message.message?message.message:message}
                        </div>

                        <div className={style.icon}>
                            {/* <FaRegCheckCircle size="40"/> */}
                            <br/>
                        </div>

                    <div className={style.button}>
                        <div className={`btn ${type} px-5`} onClick={e=>setMessage(false)}>Ok</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MessageBox;